"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.session = exports.local = void 0;
var _storageFactory = require("storage-factory");
var local = exports.local = (0, _storageFactory.storageFactory)(function () {
  return localStorage;
});
var session = exports.session = (0, _storageFactory.storageFactory)(function () {
  return sessionStorage;
});